import {
  CALL_API,
} from 'redux-api-middleware'
import {
  LOAD_EXAMPLE_SUCCESS,
  CHANGE_EXAMPLE_SUCCESS,
  CREATE_EXAM_SUCCESS,
  CHOOSE_EXAM_SUCCESS,
  LOAD_CATEGORYEXAM_REQUEST,
  LOAD_CATEGORYEXAM_SUCCESS,
  LOAD_CATEGORYEXAM_FAILURE,
  LOAD_LISTEXAM_REQUEST,
  LOAD_LISTEXAM_SUCCESS,
  LOAD_LISTEXAM_FAILURE,
  SAVE_SECTION_SUCCESS,
  LOAD_EXAMOVERVIEW_REQUEST,
  LOAD_EXAMOVERVIEW_SUCCESS,
  LOAD_EXAMOVERVIEW_FAILURE,
  SET_TIMER_SUCCESS,
  LOAD_SUBCATEGORYEXAM_REQUEST,
  LOAD_SUBCATEGORYEXAM_SUCCESS,
  LOAD_SUBCATEGORYEXAM_FAILURE,
  SET_TIMESTART_SUCCESS,
  SUBMIT_ANSWER_REQUEST,
  SUBMIT_ANSWER_SUCCESS,
  SUBMIT_ANSWER_FAILURE,
  SUBMIT_REVIEWEXAM_REQUEST,
  SUBMIT_REVIEWEXAM_SUCCESS,
  SUBMIT_REVIEWEXAM_FAILURE,
  DELETE_REVIEWEXAM_REQUEST,
  DELETE_REVIEWEXAM_SUCCESS,
  DELETE_REVIEWEXAM_FAILURE,
  SAVE_EXAMPLE_SUCCESS,
  LOAD_QUESTIONEXAM_REQUEST,
  LOAD_QUESTIONEXAM_SUCCESS,
  LOAD_QUESTIONEXAM_FAILURE,
  SET_EXAMPLE_SUCCESS,
  SET_INTERNET_FAILURE,
  LOAD_TESTEXAMOVERVIEW_REQUEST,
  LOAD_TESTEXAMOVERVIEW_SUCCESS,
  LOAD_TESTEXAMOVERVIEW_FAILURE,
  LOAD_ARTICLE_REQUEST,
  LOAD_ARTICLE_SUCCESS,
  LOAD_ARTICLE_FAILURE,
  LOAD_HISTORYTESTEXAM_REQUEST,
  LOAD_HISTORYTESTEXAM_SUCCESS,
  LOAD_HISTORYTESTEXAM_FAILURE,
  LOAD_PACKAGE_FAILURE,
  LOAD_PACKAGE_REQUEST,
  LOAD_PACKAGE_SUCCESS,
} from './types'
import {
  REVIEW_EX,
  DELETE_REVIEW_EX,
} from '../constant'

import {
  changeRoute,
} from '../actions'

import { token } from '../utils'
const headers = {
  'x-session-token': token,
  'server-name': 'deknerd',
}
export const loadExample = () => ({
  type: LOAD_EXAMPLE_SUCCESS,
})
export const changeExample = index => ({
  type: CHANGE_EXAMPLE_SUCCESS,
  data: index,
})
export const createExample = example => ({
  type: CREATE_EXAM_SUCCESS,
  data: example,
})
export const chooseExample = changedChoice => ({
  type: CHOOSE_EXAM_SUCCESS,
  data: changedChoice,
})
export const loadCategoryExam = (endpoint) => {
  return {
    [CALL_API]: {
      endpoint,
      method: 'GET',
      headers,
      types: [
        LOAD_CATEGORYEXAM_REQUEST, LOAD_CATEGORYEXAM_SUCCESS, LOAD_CATEGORYEXAM_FAILURE,
      ],
    },
  }
}
export const loadPackage= (endpoint) => {
  return {
    [CALL_API]: {
      endpoint,
      method: 'GET',
      headers,
      types: [
        LOAD_PACKAGE_REQUEST, LOAD_PACKAGE_SUCCESS, LOAD_PACKAGE_FAILURE,
      ],
    },
  }
}
export const loadSubCategoryExam = (endpoint) => {
  return {
    [CALL_API]: {
      endpoint,
      method: 'GET',
      headers,
      types: [
        LOAD_SUBCATEGORYEXAM_REQUEST, LOAD_SUBCATEGORYEXAM_SUCCESS, LOAD_SUBCATEGORYEXAM_FAILURE,
      ],
    },
  }
}
export const loadListExam = (endpoint) => {
  return {
    [CALL_API]: {
      endpoint,
      method: 'GET',
      headers,
      types: [
        LOAD_LISTEXAM_REQUEST, LOAD_LISTEXAM_SUCCESS, LOAD_LISTEXAM_FAILURE,
      ],
    },
  }
}
export const saveSection = (section) => {
  return {
    type: SAVE_SECTION_SUCCESS,
    data: section,
  }
}
export const loadExamOverview = (endpoint, tokenMobile = null) => {
  return {
    [CALL_API]: {
      endpoint,
      method: 'GET',
      headers: {
        'x-session-token': tokenMobile !== null ? tokenMobile : token,
        'server-name': 'deknerd',
      },
      types: [LOAD_EXAMOVERVIEW_REQUEST, {
        type: LOAD_EXAMOVERVIEW_SUCCESS,
        payload: async (action, state, res) => {
          const response = await res.json()
          return response
        },
      }, {
        type: LOAD_EXAMOVERVIEW_FAILURE,
        payload: async (action, state, res) => {
          const response = await res.json()
          return response
        },
      },
      ],
    },
  }
}
export const loadTestExamOverview = (endpoint) => {
  return {
    [CALL_API]: {
      endpoint,
      method: 'GET',
      headers,
      types: [LOAD_TESTEXAMOVERVIEW_REQUEST, {
        type: LOAD_TESTEXAMOVERVIEW_SUCCESS,
        payload: async (action, state, res) => {
          const response = await res.json()
          return response
        },
      }, LOAD_TESTEXAMOVERVIEW_FAILURE,
      ],
    },
  }
}
export const loadArticleExam = (endpoint) => {
  return {
    [CALL_API]: {
      endpoint,
      method: 'GET',
      headers,
      types: [LOAD_ARTICLE_REQUEST, {
        type: LOAD_ARTICLE_SUCCESS,
        payload: async (action, state, res) => {
          const response = await res.json()
          return response
        },
      }, LOAD_ARTICLE_FAILURE,
      ],
    },
  }
}
export const loadQuestionExam = (endpoint, tokenMobile = null) => {
  return {
    [CALL_API]: {
      endpoint,
      method: 'GET',
      headers: {
        'x-session-token': tokenMobile !== null ? tokenMobile : token,
        'server-name': 'deknerd',
      },
      types: [
        LOAD_QUESTIONEXAM_REQUEST,
        { type: LOAD_QUESTIONEXAM_SUCCESS,
          payload: async (action, state, res) => {
            const response = await res.json()
            await sessionStorage.setItem('LoadQuestionSuccess', true)
            return response
          },
        }, LOAD_QUESTIONEXAM_FAILURE,
      ],
    },
  }
}
export const loadHistoryExam = (endpoint) => {
  return {
    [CALL_API]: {
      endpoint,
      method: 'GET',
      headers,
      types: [
        LOAD_HISTORYTESTEXAM_REQUEST,
        { type: LOAD_HISTORYTESTEXAM_SUCCESS,
          payload: async (action, state, res) => {
            const response = await res.json()
            await sessionStorage.setItem('LoadQuestionSuccess', true)
            return response
          },
        }, LOAD_HISTORYTESTEXAM_FAILURE,
      ],
    },
  }
}
export const setTimer = (timer) => {
  return {
    type: SET_TIMER_SUCCESS,
    data: timer,
  }
}
export const setTimeStart = (timeStart) => {
  return {
    type: SET_TIMESTART_SUCCESS,
    data: timeStart,
  }
}
export const setStoreExample = (example) => {
  return {
    type: SAVE_EXAMPLE_SUCCESS,
    data: example,
  }
}
export const submitAnswer = (endpoint, dataForm, slugName, tokenMobile = null, sectionId = null, lectureId = null, productId = null) => {
  const formData = new FormData()
  formData.append('answer', `[${dataForm.answer}]`)
  // dataForm.answer.map(ans => (
  //   formData.append('answer', ans)
  // ))
  formData.append('examId', dataForm.id)
  formData.append('timer', dataForm.timer)
  // formData.append('categoryExams', dataForm.categoryExams)
  formData.append('usedTimer', dataForm.useTimer)
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint,
        method: 'POST',
        // body: JSON.stringify({ ...dataForm }),
        // body: JSON.stringify({ ...dataForm }),
        body: formData,
        headers: {
          // Accept: 'application/json',
          // 'Content-Type': 'application/json',
          'x-session-token': tokenMobile !== null ? tokenMobile : token,
          'server-name': 'deknerd',
        },
        types: [{
          type: SUBMIT_ANSWER_REQUEST,
          payload: async (action, state, res) => {
            if(window.navigator.onLine){
              sessionStorage.setItem("pendingSubmit", "true")
            }
            return res
          },
          // error: true,
          // payload: 'internet connection error', // An ApiError object
        },
        {
          type: SUBMIT_ANSWER_SUCCESS,
          payload: async (action, state, res) => {
            const response = await res.json()
            let pathName = ''
            sessionStorage.setItem("pendingSubmit", "false")
            if (sessionStorage.getItem('typeExam') !== null) {
              pathName = sessionStorage.getItem('typeExam')
              // sessionStorage.removeItem("typeExam")
              sessionStorage.removeItem('testExam')
              await (window.location.href = pathName)
            } else if(tokenMobile !== null) {
              pathName = `/eTestingReviewResultMobile/${productId}/${slugName}/?productId=${productId}&sectionId=${sectionId}&lectureId=${lectureId}&token=${tokenMobile}`
              await dispatch(changeRoute(pathName))
            }else {
              pathName = `/eTestingReviewResult/${slugName}`
              await dispatch(changeRoute(pathName))
            }
            // await dispatch(changeRoute(pathName))
            // await (window.location.href = pathName)
            // await dispatch(changeRoute(pathName))
            return response
          },
        },
        {
          type: SUBMIT_ANSWER_FAILURE,
          payload: async (action, state, res) => {
            sessionStorage.setItem("pendingSubmit", "false")
            return res.status
          },
          // meta: (action, state, res) => {
          //   if (res) {
          //     return {
          //       status: res.status,
          //       statusText: res.statusText,
          //     }
          //   }
          //   return {
          //     status: 'Network request failed',
          //   }
          // },
          // error: true,
          // payload: 'internet connection error', // An ApiError object
          meta: (action, state, res) => {
            if (res) {
              return {
                status: res.status,
                statusText: res.statusText,
              }
            }
            sessionStorage.setItem("submitingAnswer", "false")
            return {
              status: 'Network request failed',
            }
          },
        },
        ],
      },
    })
  }
}
export const submitReviewExam = (form) => {
  const formData = new FormData()
  Object.keys(form).forEach((key) => {
    formData.append(key, form[key])
  })
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint: REVIEW_EX,
        method: 'POST',
        body: formData,
        headers,
        types: [SUBMIT_REVIEWEXAM_REQUEST, SUBMIT_REVIEWEXAM_SUCCESS, SUBMIT_REVIEWEXAM_FAILURE],
      },
    })
  }
}
export const deleteReviewExam = (id) => {
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint: DELETE_REVIEW_EX(id),
        method: 'DELETE',
        headers,
        types: [DELETE_REVIEWEXAM_REQUEST, DELETE_REVIEWEXAM_SUCCESS, DELETE_REVIEWEXAM_FAILURE],
      },
    })
  }
}
export const setExamStore = exam => ({
  type: SET_EXAMPLE_SUCCESS,
  data: exam,
})
export const setInternetConnection = () => ({
  type: SET_INTERNET_FAILURE,
  data: false,
})




// WEBPACK FOOTER //
// ./src/actions/example.js